import Col from "../Col";
import Row from "../Row";
import styled from "styled-components";
import { Box, Grid } from "@mui/material";
import { SECONDARY_MENU_HEIGHT, TOP_NAV_Z_INDEX } from "../topNav/topNav.style";

export const StyledGrid = styled(Grid)(({ theme }) => `
    color: ${theme.uptimeColors.mainTheme.primary};
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
    min-width : 284px;
    display: inline-block !important;
    width: auto;
    height: ${theme.uptimeSpace[20] + 10}px !important;
`)

export const StyledRow = styled(Row)(({ theme }) => `
    margin: 0 !important;
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    white-space: normal
    cursor: default;
    padding: 0;
    transform: translateX(-8px)!important;
`)

export const StyledCol = styled(Col)<{ level: number }>(({ theme, level }) => `
    padding: ${theme.uptimeSpace[5] + 1}px ${level > 0 ? theme.uptimeSpace[6] : theme.uptimeSpace[12]}px 11px ${theme.uptimeSpace[0]}px !important;
`)

export const StyledTypography = styled('a')<{ level?: number, pseudoStyle?: string }>(({ theme, level = 0, pseudoStyle = '' }) => `
   display: flex;
   align-items: center;
   font-weight: 600;
   font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
   transition: background-color .3s ease-in-out;
   padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[4]}px;
   width: 100%;
   color: ${theme.uptimeColors.menuColors.secondaryMenu?.textColor ? theme.uptimeColors.menuColors.secondaryMenu?.textColor : theme.uptimeColors.grayScales.black} !important;
   height: 50px;
   position: relative;
   &:hover {
    text-decoration: none;
    border-radius: ${theme.uptimeSpace[2]}px;
    background-color: ${theme.uptimeColors.menuColors.secondaryMenu?.hover ? theme.uptimeColors.menuColors.secondaryMenu?.hover : theme.uptimeColors.grayScales.grayishBackground} !important;
   }
   &.active {
    &::before {
        content: "";
        position: absolute;
        background-color: ${theme.uptimeColors.menuColors.secondaryMenu?.active ? theme.uptimeColors.menuColors.secondaryMenu?.active : theme.uptimeColors.mainTheme.primary} !important;
        width: 100%;
        height: 3px;    
        bottom: 0px;
        transform: translateY(7px);
        left: 0;
    }
   }
   &.focus {
    border-radius: ${theme.uptimeSpace[2]}px;
    background-color: ${theme.uptimeColors.menuColors.secondaryMenu?.focus ? theme.uptimeColors.menuColors.secondaryMenu?.focus : theme.uptimeColors.grayScales.grayishBackground} !important;
   }
   transform: translateY(-4px);
   ::after {
        ${pseudoStyle}
        margin-left: ${level > 0 ? 'auto' : `${theme.uptimeSpace[4]}px`};
        background-color: ${level > 0 ? theme.uptimeColors.grayScales.darkGray : 'currentColor'};
    }
`)

export const StyledGroupMenuTopNav = styled(Box)(({ theme, hidden }) => `
    box-shadow: ${theme.shadows.md};
    background-color: ${theme.uptimeColors.grayScales.white} !important;
    width: 100vw;
    display: ${hidden ? 'none' : 'block'};
    height: ${SECONDARY_MENU_HEIGHT}px;
    position: fixed;
    left: 0;
    z-index: ${TOP_NAV_Z_INDEX - 1};
    top: ${SECONDARY_MENU_HEIGHT}px;
    cursor: default;
    .MuiGrid-spacing-xs-3 {
        margin: 0 !important; 
    }
`);
export const DropDownContent = styled.li(({ theme }) => `
    position: relative;
    height: ${theme.uptimeSpace[20] + 10}px;
`);
export const StyledContainer = styled.div(({ theme }) => `
    height: ${theme.uptimeSpace[20]}vh;
    .marketplace-menu {
        padding-left: ${theme.uptimeSpace[20]}px;
    }
`);

export const StyledDropDown = styled(Box)(({ theme }) => `
    position: absolute;
	right: 0;
	left: 0;
    top: ${theme.uptimeSpace[20] + 25}px;
	box-shadow: ${theme.shadows.md};
	font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
	z-index: 999;
	width: 284px;
    height: auto;
	padding: ${theme.uptimeSpace[1]}px 0 ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[6]}px;
	background-color: ${theme.uptimeColors.grayScales.white};
	border-radius: ${theme.uptimeSpace[1]}px;
    display: none;
	&.dropdown-submenu {
		position: absolute;
		left: 100%;
		top: -2px;
	}
    &.show {
        display: block;
    }
`);